import { Injectable } from '@angular/core';
import { ErrorComponent } from '../components/error/error.component';
import { PortalService } from './portal.service';
import { NxiF2Title } from '@pershing/nxi-portalcomponents';
import { NxiF2Component } from '@pershing/nxi-portalcomponents';
import { AllSettingsComponent, FourthLevelComponent, PageHeaderComponent } from '@pershing/nxi-ng-modern-navigation';
import { ThirdLevelComponent } from '@pershing/nxi-ng-modern-navigation';
import { ScreenerNavComponent } from '@pershing/nxi-ng-modern-navigation';
import { ScreenerNavCustomComponent, ThirdLevelMobileComponent, MobileFourthLevelNavComponent, MobileDropDownComponent } from '@pershing/nxi-ng-modern-navigation';
import { NxiF2Common } from '@pershing/nxi-portalcomponents';
import { AlertsContainerComponent } from '@pershing/nxi-ng-modern-alerts';
import { MarketAlertsWrapperComponent } from '@pershing/nxi-ng-mod';
import { ContentManagementComponent} from "@pershing/nxi-ng-common";


@Injectable({
  providedIn: 'root'
})
export class PageService {



  // load page configuration
  private _config: { [key: string]: any } = {};

  // load default page layout
  private _layout: { [key: string]: any } = {};

  // map of components owned by portal that can be loaded dynamically
  // by the panels in the page
  private _componentMap: { [key: string] : any } = {
      "ErrorComponent": ErrorComponent,
      "F2Title": NxiF2Title,
      "F2Component": NxiF2Component,
      "F2Common": NxiF2Common,
      "FourthLevelNavigation": FourthLevelComponent,
      "ThirdLevelNavigation": ThirdLevelComponent,
      "ThirdLevelMobileComponent": ThirdLevelMobileComponent,
      "ScreenerNavigation": ScreenerNavComponent,
      "ScreenerNavigationCustom": ScreenerNavCustomComponent,
      "AlertsContainerCustom": AlertsContainerComponent,
      "marketalertsAgmt": MarketAlertsWrapperComponent,
      "AllSettings": AllSettingsComponent,
      "FourthLevelMobileNavigation": MobileFourthLevelNavComponent,
      "MobileDropdownNavigation": MobileDropDownComponent,   
      "contentManagementComponent" : ContentManagementComponent,
      "PageHeader": PageHeaderComponent
  };


  constructor(private _portalService: PortalService) {

    this._config = this._portalService.getAppSetting("pageConfig") ?
      this._portalService.getAppSetting("pageConfig") : this._portalService.getPortalConfig('page-config');

    this._layout = this._portalService.getPortalConfig('default-layout');

  }

  // returns panel layout from config
  getLayout(pageName: string): any {
    try {
      return this._config[pageName] && this._config[pageName].deviceConfigurations ?
        this._config[pageName].deviceConfigurations : "";
    }
    catch (e) {
      return this._config['default'].deviceConfigurations;
    }
  }

  // returns predefined component
  // TODO: fix the map above
  getComponentFromMap(component: string): any {

    if (component in this._componentMap)
      return this._componentMap[component];
    else
      return ErrorComponent;
  }

  // return the name of menu that page belongs to
  getPageMenu(pageName: string): string {
    try {
      const menu = this._config[pageName].menu;
      if (menu)
        return menu;
      else
        return "postLogin";
    }
    catch {
      return "postLogin";
    }
  }

  isPagePublic(pageName: string): boolean {
    // if the user is logged in then return any page
    // otherwise allow only public pages
    if (this._config && this._config[pageName]?.security?.toLowerCase() === "public")
      return true;
    else
      return false;
  }

}
